import _classCallCheck from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Picker from './picker';

var IconPicker =
/*#__PURE__*/
function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    var _this;

    _classCallCheck(this, IconPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPicker).call(this, select));

    _this.container.classList.add('ql-icon-picker');

    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');

    _this.selectItem(_this.defaultItem);

    return _this;
  }

  _createClass(IconPicker, [{
    key: "selectItem",
    value: function selectItem(item, trigger) {
      _get(_getPrototypeOf(IconPicker.prototype), "selectItem", this).call(this, item, trigger);

      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(Picker);

export default IconPicker;